import React from "react";
import getStaticAssetUrl from "../../../../../utils/assetUtils";

const CloudBackground: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="min-h-screen relative overflow-hidden">
    <div
      className="absolute inset-0 bg-cover bg-center bg-[#1E4D8C]"
      style={{
        backgroundImage: `url('${getStaticAssetUrl(
          "assets/images/clouds.png",
        )}')`,
      }}
    />
    <div className="relative z-10">{children}</div>
  </div>
);

export default CloudBackground;
